
import { Options, mixins } from "vue-class-component";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";
import { RoutingUtilityMixin } from "@/mixins";

const ALBUMS_ROUTE = "3d-viewer/albums/root";

@Options({
  name: "AlbumsButton",
  components: {
    SvgIcon,
  },
})
export default class AlbumsButton extends mixins(RoutingUtilityMixin) {
  protected get isAlbumsRoute(): boolean {
    return this.$route.name === ALBUMS_ROUTE;
  }

  protected get albumsRoute(): string {
    return this.constructLocaleAwarePath("/albums");
  }
}
